import { Flex, HistoryBackButton, Result } from '@/components';
import { CONTENT_HEADER_HEIGHT } from '@/utils';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  backRoute?: string;
  height?: string;
  message?: string;
};

const innerPaddingY = 24 * 2;
const contentHeight = `calc(100vh - ${CONTENT_HEADER_HEIGHT}px - ${innerPaddingY}px)`;

export const NotAuthorized: FC<Props> = ({ height, backRoute, message }) => {
  const { t } = useTranslation();
  return (
    <Flex
      style={{
        height: height ?? contentHeight,
      }}
      align="center"
      justify="center"
    >
      <Result
        status="403"
        title={t('error-message-not-authorized')}
        subTitle={message ?? undefined}
        extra={backRoute && <HistoryBackButton backRoute={backRoute} />}
      />
    </Flex>
  );
};
